var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['card', _vm.$store.state.style]},[_c('div',{staticClass:"news"},[_c('div',{staticClass:"msg"},[_c('div',{staticClass:"van-multi-ellipsis--l3"},[_vm._v(_vm._s(_vm.data.title))])]),_c('img',{attrs:{"src":_vm.data.pictureUrl}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }